import {
	HttpInterceptor,
} from 'utils/http';
import {
	authInterceptor,
} from './auth.interceptor';
import {
	userTimeInterceptor,
} from './user-time.interceptor';
import {
	responseStatusInterceptor,
} from './response-status.interceptor';
import {
	xCorrelationIdInterceptor,
} from './x-correlation-id.interceptor';

/**
 * Here we group all the interceptors so that we have them all in one place,
 * and hopefully can keep track of what interceptors we have in use and what order they are run in.
 */

export const responseInterceptors: HttpInterceptor<Response>[] = [
	responseStatusInterceptor,
];
export const requestInterceptors: HttpInterceptor<RequestInit>[] = [
	authInterceptor,
	xCorrelationIdInterceptor,
	userTimeInterceptor,
];